import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';

/**
 * The landing-preview hand-off (RFC 128): `/preview?surface=partner|employee&experience=current|beta`,
 * loaded in a frame by tio-admin. The hand-off itself (grant, session, `/me`,
 * landing) runs in the page component so the loading state paints at once.
 */
export default class PreviewRoute extends Route {
  model(_params: Record<string, unknown>, transition: Transition) {
    const { surface, experience } = transition.to?.queryParams ?? {};
    return { surface, experience };
  }
}
